let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kJuAQ")).then(() => parcelRequire('7elOh'));